import React, { Component } from 'react';
import { computed } from 'mobx';
import { inject, observer } from 'mobx-react';
import { Box, FlexColumn } from 'core/components';
import DeckHeading from 'app/components/decks/DeckHeading';
import Page, { NAV_HEIGHT } from 'app/components/page/Page';
import { withRouter } from 'react-router-dom';
import BoardGridView from 'app/views/boards/BoardGridView';
import UdeToolBar from 'app/views/boards/panels/ude/UdeToolBar';

@withRouter
@inject('$auth', '$boards')
@observer
class Deck extends Component {
  static defaultProps = {
    title: undefined,
    description: undefined,
    hideSubnav: true,
    icon: undefined,
    tools: undefined,
    fullWidthTools: false,
    type: undefined,
    canCustomize: false,
    pinnedBoardId: undefined
  };

  state = {
    loading: true,
    board: null
  };

  componentDidMount() {
    this.fetchBoard();
  }

  componentDidUpdate(prevProps) {
    const { type, pinnedBoardId } = this.props;

    if (prevProps.type !== type || prevProps.pinnedBoardId !== pinnedBoardId) {
      this.fetchBoard();
    }
  }

  async fetchBoard() {
    const { $boards, type, canCustomize, pinnedBoardId } = this.props;
    const board = await $boards.getPersonalBoard(type, { canCustomize, boardId: pinnedBoardId });
    this.setState({ board, loading: false });
  }

  handleAddPanel = (type = 'section') => {
    const { history, location } = this.props;
    const { board } = this.state;

    if (type === 'section') {
      board.addPanel({ title: 'Untitled Section', type });
    } else {
      history.push(`/v4/library/boards/${board.id}/panel/${type}`, { from: location });
    }
  };

  handleReset = () => {
    const { board } = this.state;
    return board.discardDraftPanels();
  };

  @computed
  get isUnsaved() {
    const { board } = this.state;
    return !!board?.isDirty;
  }

  @computed
  get effectiveCanEdit() {
    const { canCustomize } = this.props;
    const { board } = this.state;
    return canCustomize && !!board?.canEdit;
  }

  render() {
    const { description, hideSetupGauge, hideSubnav, icon, iconSize, title, tools, fullWidthTools } = this.props;

    const { loading, board } = this.state;

    return (
      <Page
        title={title}
        px={0}
        py={0}
        hideSubnav={hideSubnav}
        hideSetupGauge={hideSetupGauge}
        overflow="hidden"
        overrideFullScreen
      >
        <FlexColumn overflow="hidden" flex={1} position="relative" height={`calc(100vh - ${NAV_HEIGHT}px)`}>
          <DeckHeading
            title={title}
            description={description}
            icon={icon}
            iconSize={iconSize}
            px={3}
            py={2}
            width="100%"
            board={board}
            isUnsaved={this.isUnsaved}
            onAddPanel={this.handleAddPanel}
            onReset={this.handleReset}
            canCustomize={this.effectiveCanEdit}
          >
            <FlexColumn flex={fullWidthTools ? 1 : 'auto'} alignItems="flex-end" justifyContent="center">
              {tools}
            </FlexColumn>
          </DeckHeading>
          {board?.panelCollection.hasUdePanel && (
            <Box bg="decks.background" py={1} px={3}>
              <UdeToolBar board={board} onTimeChange={board.setTimeRange} onLiveUpdateChange={board.setLiveUpdate} />
            </Box>
          )}
          <BoardGridView board={board} loading={loading} canEdit={this.effectiveCanEdit} />
        </FlexColumn>
      </Page>
    );
  }
}

export default Deck;
